import { Controller } from "@hotwired/stimulus";
import { renderChart } from "./ag_charts_backend";
import type { ChartHandle, NeutralChartConfig } from "./ag_charts_backend";

// Internal backend selector — the ONLY place a future backend (e.g. Chartkick) would plug
// in. Callers of Application::Toolkit::ChartComponent never see this constant; it never
// crosses the component boundary (spec 010 Decision 4 / FR-028).
const BACKEND = "ag-charts-community" as const;

export default class extends Controller {
  static targets = ["canvas"];
  static values = { config: Object };

  declare readonly canvasTarget: HTMLElement;
  declare readonly hasCanvasTarget: boolean;
  declare readonly configValue: NeutralChartConfig;

  private handle: ChartHandle | null = null;

  connect(): void {
    if (!this.hasCanvasTarget) return;

    switch (BACKEND) {
      case "ag-charts-community":
        this.handle = renderChart(this.canvasTarget, this.configValue);
        break;
      default:
        // Exhaustiveness guard — flags a missing branch if BACKEND ever grows a value.
        throw new Error(`[chart-component] unknown backend: ${BACKEND as string}`);
    }
  }

  disconnect(): void {
    this.handle?.destroy();
    this.handle = null;
  }
}
